import _ from 'underscore';
import FilterToggle from './modules/filter-toggle';
import Lazyload from './modules/lazyload';
import { updateAssetUrlDimensions } from './modules/widen-utils';
import { getTruncatedWidenUrl, localStorageSwatchEventHandlers, getSwatchProductUrlParams } from './modules/swatchbook-utils';
import { getItemsFromAccount, removeItemFromAccount, saveItemToAccount } from './modules/consumer-account/storage-actions';
import { updateAccountIconStatus } from './modules/consumer-account/account-status-helpers';

// console.log('\n\n\n*************************\n\nswatch-ordering.js ver: 1.1.0 \n\n*************************\n\n\n');

_.templateSettings = {
  interpolate: /\{\{(.+?)\}\}/g,
};

const modalTemplate =
  `<div>
    <div class="modal-overlay modal-visible"></div>
    <div class="modal modal-swatch modal-visible" data-open-from="swatch-modal" tabindex="0">
      <div class="modal-inner">
        <button type="button" class="btn-close" aria-label="Close Modal"></button>
        <div class="row">
          <div class="col">
            <div class="asset-loader">
              <div class="ldr-dual-ring"></div>
            </div>
            <div class="modal-image">
              <img src="{{ imageSrc }}" alt="{{ imageAlt }}">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="gallery-modal-caption">
      <button class="caption-titlebar" aria-expanded="true">
        <div class="caption-title">
          <span class="icon"></span>
          About this Swatch
        </div>
      </button>
      <div class="caption-inner">
        <div class="caption-inner-left">
          <div class="caption-details-grid">
            <div>
              <div class="caption-header">Product Line</div>
              <div class="body-sm">{{ productLine }}</div>
            </div>
            <div>
              <div class="caption-header">Collection</div>
              <div class="body-sm">{{ collection }}</div>
            </div>
            <div>
              <div class="caption-header">Category</div>
              <div class="body-sm">{{ swatchCatName }}</div>
            </div>
            <div>
              <div class="caption-header">Color</div>
              <div class="body-sm">{{ colorName }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>`;

const visualizerDetailsTemplate =
  `<div>
    <a href="/visualization/?minimal=&amp;Brand=Bali&amp;Model={{ visualizerModelId }}&amp;ProgramFamilyName={{ visualizerProgamFamilyName }}&amp;OE.CLR={{ colorNumber }}" class="visualizer-link" onclick="event.stopPropagation();">View in Visualizer</a>
    <span class="show-detail-btn">
      <button class="icon icon--zoom"></button>
    </span>
  </div>`;

const modalTemplateVals = _.template(modalTemplate);
const modal = document.querySelector('.swatch-modal-container');
let captionMinimized = false;
let previousElementInFocus = null;

const setPreviousElementInFocus = (element) => {
  previousElementInFocus = element;
};

const resetFocus = () => {
  if (previousElementInFocus) {
    previousElementInFocus.focus();
  }
};

const getAddLabel = (colorName) => {
  const { isAuthenticatedDealer } = window;
  if (isAuthenticatedDealer) {
    return `Add<span class="sr-only"> ${colorName}</span> Swatch<span class="sr-only"> To Order</span>`;
  }
  return `Add<span class="sr-only"> ${colorName} Swatch</span> To Favorites`;
};

const getRemoveLabel = (colorName) => {
  const { isAuthenticatedDealer } = window;
  if (isAuthenticatedDealer) {
    return `Remove<span class="sr-only"> ${colorName}</span> Swatch<span class="sr-only"> From Order</span>`;
  }
  return `Remove<span class="sr-only"> ${colorName} Swatch</span> From Favorites`;
};

const captionTitlebarClickHandler = () => {
  const caption = modal.querySelector('.gallery-modal-caption');
  const titlebarBtn = caption.querySelector('.caption-titlebar');
  captionMinimized = !captionMinimized;
  if (!captionMinimized) {
    caption.style.bottom = `-${caption.offsetHeight - 36}px`;
    titlebarBtn.setAttribute('aria-expanded', 'false');
  } else {
    caption.removeAttribute('style');
    titlebarBtn.setAttribute('aria-expanded', 'true');
  }
};

const removeModal = (event) => {
  let isModalRemoved = false;
  if (modal.firstChild !== null) {
    if (event.target.classList.contains('modal-overlay')) {
      isModalRemoved = true;
    } else if (event.target.classList.contains('btn-close')) {
      isModalRemoved = true;
    }
    if (isModalRemoved) {
      // Caption event handler
      const caption = modal.querySelector('.caption-titlebar');
      caption.removeEventListener('click', captionTitlebarClickHandler);
      modal.removeChild(modal.firstChild);
      document.removeEventListener('click', removeModal);
      resetFocus();
    }
  }
};

const addModal = (data) => {
  const isModalAdded = document.querySelector('.modal-swatch');
  if (isModalAdded !== null) {
    return;
  }
  const div = document.createElement('div');
  const compiled = modalTemplateVals(data);
  div.innerHTML = compiled;
  modal.appendChild(div.firstChild);
  // Set focus state
  setPreviousElementInFocus(document.activeElement);
  modal.querySelector('.modal').focus();
  // Caption event handler
  const caption = modal.querySelector('.caption-titlebar');
  captionMinimized = true;
  caption.addEventListener('click', captionTitlebarClickHandler);
  document.addEventListener('click', removeModal);
};

const addModalEventHandlers = () => {
  const swatchModalBtns = document.querySelectorAll('.swatch-link');
  if (swatchModalBtns) {
    [].map.call(swatchModalBtns, swatch => swatch.addEventListener('click', () => {
      const img = swatch.querySelector('img');
      let src = img.getAttribute('srcset');
      // IE11 Fix
      if (src === null) {
        src = img.getAttribute('src');
      }
      const item = {
        imageSrc: updateAssetUrlDimensions({
          src,
          width: window.innerHeight,
          height: window.innerHeight,
        }),
        imageAlt: img.getAttribute('alt'),
        colorName: img.getAttribute('data-colorName'),
        collection: img.getAttribute('data-collection'),
        productLine: img.getAttribute('data-productLine'),
        swatchCatName: img.getAttribute('data-swatchCatName'),
      };
      addModal(item);
    }));
  }
};

const getItemBySwatchId = (data, id) => (
  data.find(item => id === `swatch-${item['style-id']}-${item['swatch-category-id']}-${item['swatch-id']}`)
);

const accountStorageSwatchEventHandler = (item, swatches) => {
  // console.log('swatch-ordering.js, accountStorageSwatchEventHandler');
  const btn = item.querySelector('.swatchbutton');
  if (btn === null) { // In the event that "swatch is not available, there is no button"
    return;
  }
  const label = item.querySelector('.swatchbutton--label');
  const colorName = btn.getAttribute('data-colorName');
  const id = item.getAttribute('id');
  // Toggle button to remove state if in swatchbook
  const swatchAsset = getItemBySwatchId(swatches, id);
  if (swatchAsset) {
    btn.classList.add('is-active');
    // Add data-asset-id attribute to button
    btn.setAttribute('data-asset-id', swatchAsset['digital-swatch-id']);
    label.innerHTML = getRemoveLabel(colorName);
  } else {
    btn.classList.remove('is-active');
    label.innerHTML = getAddLabel(colorName);
  }
  // Add/remove swatch event handlers
  btn.addEventListener('click', (event) => {
    event.stopPropagation();
    btn.classList.add('btn--disabled');
    if (btn.classList.toString().indexOf('is-active') !== -1) {
      // Remove
      const assetId = btn.getAttribute('data-asset-id');
      removeItemFromAccount('swatch', assetId, () => {
        btn.classList.remove('is-active');
        label.innerHTML = getAddLabel(colorName);
        // Update cart
        updateAccountIconStatus();
      });
    } else {
      // Add
      saveItemToAccount(
        'swatch',
        {
          productLineCode: btn.getAttribute('data-productLineCode'),
          colorNumber: btn.getAttribute('data-colorNumber'),
          swatchId: btn.getAttribute('data-swatchId'),
          widenUrl: getTruncatedWidenUrl(btn.getAttribute('data-imageUrl')),
        },
        (data) => {
          btn.classList.remove('btn--disabled');
          if (data.success) {
            btn.classList.add('is-active');
            label.innerHTML = getRemoveLabel(colorName);
            // Set asset id
            btn.setAttribute('data-asset-id', data['asset-id']);
            // Update cart
            updateAccountIconStatus();
          }
        },
      );
    }
  });
};

const addSwatchVisualizationNav = (data) => {
  const {
    visualizerModelId,
    visualizerProgamFamilyName,
  } = data;
  // Go through each swatch present (all are same product) in DOM and append visualization links, if exist
  if (visualizerModelId === null || visualizerProgamFamilyName === null) {
    return;
  }
  const visualizerDetailsTemplateVals = _.template(visualizerDetailsTemplate);
  const detailDivs = document.querySelectorAll('.swatch');
  for (let i = 0; i < detailDivs.length; i++) { /* eslint-disable-line no-plusplus */
    // Get color number, append to data object
    const btn = detailDivs[i].querySelector('.swatchbutton');
    if (btn !== null) { // Swatch not available, no button...
      data.colorNumber = btn.getAttribute('data-colornumber');
      // Wipe existing content
      const detail = detailDivs[i].querySelector('.swatchcard--viewdetail');
      detail.innerHTML = '';
      // Create visualization detail nav
      const div = document.createElement('div');
      const compiled = visualizerDetailsTemplateVals(data);
      div.innerHTML = compiled;
      detail.appendChild(div.firstChild);
    }
  }
};

const getSwatchVisualizationParams = () => {
  const { products, id } = window;
  const product = products.find(item => item.Id === id);
  getSwatchProductUrlParams(product.Name, (responseData) => {
    addSwatchVisualizationNav(responseData);
  });
};

const addEventListeners = () => {
  // console.log('swatch-ordering.js, addEventListeners');
  if (document.querySelector('.swatch-link')) {
    // Init swatch modal
    addModalEventHandlers();
    // Every time filter is clicked, re-add modal init after partial is refreshed...
    const filters = document.querySelectorAll('.filter-event');
    [].map.call(filters, filter => filter.addEventListener('click', () => setTimeout(() => {
      addModalEventHandlers();
    }, 500)));
    // Add visualization parameters
    if (window.isVisualizerActive && window.products) {
      getSwatchVisualizationParams();
    }
    /*
      Three add-swatch use-cases
      1. Logged-in as authenticated dealer
      2. Not logged-in as dealer, logged-in as consumer
      3. Not logged-in as dealer, not logged-in as consumer
    */
    if (window.isAuthenticatedDealer) {
      // Add save to cart event handling (same as favorites saving for graber/bali)
      [].map.call(document.querySelectorAll('.swatch'), (item) => {
        localStorageSwatchEventHandlers(item);
      });
    } else if (!window.isAuthenticatedDealer && window.isAuthenticated) {
      // Get any swatches saved to account
      // before adding add/remove swatch event handlers
      getItemsFromAccount('swatch', (data) => {
        [].map.call(document.querySelectorAll('.swatch'), (item) => {
          accountStorageSwatchEventHandler(item, data.swatches);
        });
      });
    } else if (!window.isAuthenticatedDealer && !window.isAuthenticated) {
      // Skip checking for swatches and just add event handlers
      [].map.call(document.querySelectorAll('.swatch'), (item) => {
        accountStorageSwatchEventHandler(item, []);
      });
    }
  }
};

// Run on load
addEventListeners();
// Add to window
window.addSwatchOrderingEventListeners = () => {
  FilterToggle();
  Lazyload();
  addEventListeners();
};


export {
  addEventListeners, /* eslint-disable-line import/prefer-default-export */
};
